import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';
import { FinancialEndModal } from '../../modals';
import { AffiliateTypeModal } from '../../modals/affiliate-type-modal/affiliate-type-modal.component';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

@Component({
  selector: 'app-company-financial-year-end',
  templateUrl: './financial-year-end.component.html',
  styleUrls: ['./financial-year-end.component.scss'],
})
export class FinancialYearEndComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  success = '';
  error = false;
  pending = false;
  FAQs = [];
  companyRecords = [];
  recordsToDisplay = [];
  totalItems = 0;
  rows = 10;
  successMsg;
  errorMsg;
  maxSize = 3;
  currentPage = 1;
  organizationId;
  financial;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private location: Location,
    private companyOwnershipService: CompanyOwnershipService,
    private modalService: SuiModalService
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 15, page: 1 });
    this.organizationId = window.localStorage.getItem('organizationId');
    this.getPage(1);
  }

  ngOnInit(): void {}

  goBack() {
    this.location.back();
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    let payload = {
      organizationId: this.organizationId,
    };
    this.companyOwnershipService
      .getAllFinancialEnd({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.financial = res.rows;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  publish(data) {
    this.modalService
      .open(
        new ConfirmModal(
          'Publish Year?',
          'Are you sure you want to publish?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.publishing(data);
      })
      .onDeny(() => {});
  }
  publishing(data) {
    this.pending = true;
    this.error = null;
    this.companyOwnershipService
      .publishFinancialYear({
        year: data,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.success = 'Financial Year has been published';
          this.getPage(1);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  unPublishing(data) {
    this.pending = true;
    this.error = null;
    this.companyOwnershipService
      .unPublishFinancialYear({
        year: data,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.success = 'Financial Year has been unpublished';
          this.getPage(1);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  unPublish(data) {
    this.modalService
      .open(
        new ConfirmModal(
          'UnPublish Year?',
          'Are you sure you want to unpublish?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.unPublishing(data);
      })
      .onDeny(() => {});
  }
  edit(data) {
    this.modalService
      .open(
        new FinancialEndModal(
          'Edit Financial year end',
          'companyTypeId',
          data,
          true
        )
      )
      .onApprove(() => {
        this.getPage(1);
      });
  }
  searchRecords(event) {
    this.recordsToDisplay = [];
    this.companyRecords.forEach((record) => {
      if (record.companyTypeName.toLowerCase().includes(event)) {
        this.recordsToDisplay.push(record);
      }
    });
    this.totalItems = this.recordsToDisplay.length;
  }

  displayRecords(event) {}

  sortRecords(event) {
    this.recordsToDisplay.reverse();
  }

  nextPage(event) {}

  toggleAffiliateTypesVisibility(index: number) {
    this.companyRecords[index]['isCollapsed'] =
      !this.companyRecords[index]['isCollapsed'];
  }

  addAffiliateType(companyTypeId = '') {
    this.modalService
      .open(
        new FinancialEndModal(
          'New Financial year',
          'companyTypeId',
          this.companyRecords,
          false
        )
      )
      .onApprove(() => {
        this.getPage(1);
      });
  }

  appendCollapseState() {
    this.companyRecords.forEach((companyRecord) => {
      companyRecord['isCollapsed'] = true;
    });
  }
}
